import {Deserializable} from "./deserializable.model";

export class SystemLogTypeDataSectorCondition {

   log_type_data_sector_condition_id: number;
   log_type_data_sector_condition_name: string;
   log_type_data_sector_condition_description: string;

    is_active: number;
    condition_array: any;
    log_type_data_sector_id: number;
 
    //extra Display Filds
    log_type_data_sector_colour: any;



  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SystemLogTypeDataSectorCondition {
    Object.assign(this, input);

    return this;
  }


}
